// extracted by mini-css-extract-plugin
export var bodyRow = "_fa-d";
export var cardColumns = "_fa-e";
export var ellipsesOverflow = "_fa-2";
export var flatBottomCorners = "_fa-3";
export var flatTopCorners = "_fa-4";
export var headerActionsDropdown = "_fa-f";
export var headerBottomRow = "_fa-c";
export var headerTopRow = "_fa-b";
export var orderDetailsWrapper = "_fa-0";
export var orderInfoContainer = "_fa-1";
export var productDetails = "_fa-9";
export var productImage = "_fa-5";
export var responsiveTable = "_fa-8";
export var shipmentContainer = "_fa-a";
export var tableBottomLeft = "_fa-6";
export var tableBottomRight = "_fa-7";
export var trackingLink = "_fa-g";